export default __webpack_public_path__ + "assets/models/12f7931fa0288e00c357f22c83989b91.glb";